/** In-progress tour step across remounts (web SiteShell per page). */

export type NavTourProgress = {
  stepIndex: number;
  started: boolean;
};

export function navTourProgressStorageKey(track: string, slug: string): string {
  return `communio:nav-tour:progress:${track}:${slug}`;
}

export function parseNavTourProgress(raw: string | null | undefined): NavTourProgress | null {
  if (!raw) return null;
  try {
    const v = JSON.parse(raw) as Partial<NavTourProgress>;
    if (typeof v.stepIndex !== 'number' || v.stepIndex < 0) return null;
    if (v.started !== true) return null;
    return { stepIndex: Math.floor(v.stepIndex), started: true };
  } catch {
    return null;
  }
}

export function serializeNavTourProgress(progress: NavTourProgress): string {
  return JSON.stringify({ stepIndex: progress.stepIndex, started: progress.started });
}
